import { baseApi } from './baseApi'

import { PlatformSettingsDto, UpdatePlatformSettingsDto } from 'store/types'

export const platformSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlatformSettings: builder.query<PlatformSettingsDto, void>({
      query: () => ({ url: '/lab/settings/platform' }),
      providesTags: ['PlatformSettings'],
    }),
    updatePlatformSettings: builder.mutation<PlatformSettingsDto, UpdatePlatformSettingsDto>({
      query: (body) => ({
        url: '/lab/settings/platform',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['PlatformSettings'],
    }),
  }),
})

export const { useGetPlatformSettingsQuery, useUpdatePlatformSettingsMutation } = platformSettingsApi
